/* 
 *  Created by SGiri 02/14/2018
 */

import { Component } from "@angular/core";
import { MatDialog } from "@angular/material";
import { CommonService } from "~util/common.service";
import { MappingDialogComponent } from "~config/mapping-dialog/mapping-dialog.component";

@Component({
    selector: 'edit-component',
    templateUrl: './edit.component.html'
})
export class EditComponent {

    params: any;

    constructor(private dialog: MatDialog, private service: CommonService) {
    }

    agInit(params: any): void {
        this.params = params;
        if (this.service.environment !== 'DEV') {
            this.params.column.colId = -1;
        } else if (this.service.userRole != 'ADMINISTRATOR') {
            this.params.column.colId = -1;
        }
    }

    lockUnlock(params) {
        params.api.stopEditing(true);
        params.data.locked = !params.data.locked;
    }

    edit(params) {

        if (params.data.dashboardId == 0) {
            this.service.showDialog({
                header: '?',
                message: 'Please select Dashboard to update location mapping'
            })
        } else {

            let dialogRef = this.dialog.open(MappingDialogComponent, {
                width: '500px',
                data: {
                    reportId: params.data.reportId,
                    kpiId: params.data.kpiId,
                    dashboardId: params.data.dashboardId
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/edit/edit.component.ts